import {AbstractComponent} from './abstract-component';

/**
 * Helper component for `blueways/bw-captcha`.
 *
 * @author Philipp Seiler <sep@earlybird.at>
 */
export class Captcha extends AbstractComponent<null> {
  constructor() {
    super();
    this.initializeReloadCaptchaButtons();
    this.initializeReadCaptchaButtons();
  }

  /**
   * Initializes the buttons for reloading a captcha image.
   */
  private initializeReloadCaptchaButtons(): void {
    let timeout = false;
    const reloadCaptchaButtons = document.querySelectorAll<HTMLElement>('[data-reload-captcha]');
    for (const button of reloadCaptchaButtons) {
      button.addEventListener('click', () => {
        if (timeout) {
          return;
        }

        const captchaImageSelector = button.dataset.captchaImage;
        if (!captchaImageSelector) {
          throw new Error('Missing data-captcha-image.');
        }
        const captchaUrl = button.dataset.captchaUrl;
        if (!captchaUrl) {
          throw new Error('Missing data-captcha-url.');
        }
        const captchaImage = document.querySelector<HTMLImageElement>(captchaImageSelector);
        if (!captchaImage) {
          throw new Error('Missing captcha image.');
        }

        captchaImage.src = captchaUrl + '&now=' + Date.now();
        this.disableButton(button);

        timeout = true;
        setTimeout(() => {
          timeout = false;
          this.enableButton(button);
        }, 3000);
      });
    }
  }

  /**
   * Initializes the buttons for reading a captcha text aloud.
   */
  private initializeReadCaptchaButtons(): void {
    const audio = new Audio();
    const readCaptchaButtons = document.querySelectorAll<HTMLElement>('[data-read-captcha]');
    for (const button of readCaptchaButtons) {
      button.addEventListener('click', () => {
        const captchaUrl = button.dataset.captchaUrl;
        if (!captchaUrl) {
          throw new Error('Missing data-captcha-url.');
        }

        if (!audio.paused) {
          return;
        }

        fetch(captchaUrl, {
          method: 'POST'
        }).then(response => {
          return response.blob();
        }).then(blob => {
          if (audio.paused) {
            audio.src = window.URL.createObjectURL(blob);
            audio.play();
            this.disableButton(button);
          }
        });

        audio.addEventListener('ended', () => {
          this.enableButton(button);
        });
      });
    }
  }

  /**
   * Disables a captcha interaction button.
   *
   * @param {HTMLElement} button Button to disable
   */
  private disableButton(button: HTMLElement): void {
    button.classList.add('disabled');
    button.style.pointerEvents = 'none';
    button.style.opacity = '0.5';
  }

  /**
   * Enbales a captcha interaction button.
   *
   * @param {HTMLElement} button Button to enable
   */
  private enableButton(button: HTMLElement): void {
    button.classList.remove('disabled');
    button.style.pointerEvents = 'all';
    button.style.opacity = '1';
  }
}
